import { atomWithStorage } from "jotai/utils";

export const pinnedInsuredsAtom = atomWithStorage<Record<string, string>>("pinnedInsuredIds", {});
